/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiSearchGet200Response } from '../models';
// @ts-ignore
import type { ApiSearchLeaguesGet200Response } from '../models';
// @ts-ignore
import type { ApiSearchPlayersGet200Response } from '../models';
/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search for players, teams, competitions
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchGet: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiSearchGet', 'q', q)
            const localVarPath = `/api/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for leagues
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchLeaguesGet: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiSearchLeaguesGet', 'q', q)
            const localVarPath = `/api/search/leagues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for players
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchPlayersGet: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiSearchPlayersGet', 'q', q)
            const localVarPath = `/api/search/players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Search for players, teams, competitions
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSearchGet(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSearchGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSearchGet(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for leagues
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSearchLeaguesGet(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSearchLeaguesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSearchLeaguesGet(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiSearchLeaguesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for players
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSearchPlayersGet(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSearchPlayersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSearchPlayersGet(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiSearchPlayersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         * Search for players, teams, competitions
         * @param {SearchApiApiSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchGet(requestParameters: SearchApiApiSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiSearchGet200Response> {
            return localVarFp.apiSearchGet(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for leagues
         * @param {SearchApiApiSearchLeaguesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchLeaguesGet(requestParameters: SearchApiApiSearchLeaguesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiSearchLeaguesGet200Response> {
            return localVarFp.apiSearchLeaguesGet(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for players
         * @param {SearchApiApiSearchPlayersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchPlayersGet(requestParameters: SearchApiApiSearchPlayersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiSearchPlayersGet200Response> {
            return localVarFp.apiSearchPlayersGet(requestParameters.q, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiSearchGet operation in SearchApi.
 * @export
 * @interface SearchApiApiSearchGetRequest
 */
export interface SearchApiApiSearchGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchApiApiSearchGet
     */
    readonly q: string
}

/**
 * Request parameters for apiSearchLeaguesGet operation in SearchApi.
 * @export
 * @interface SearchApiApiSearchLeaguesGetRequest
 */
export interface SearchApiApiSearchLeaguesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchApiApiSearchLeaguesGet
     */
    readonly q: string
}

/**
 * Request parameters for apiSearchPlayersGet operation in SearchApi.
 * @export
 * @interface SearchApiApiSearchPlayersGetRequest
 */
export interface SearchApiApiSearchPlayersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchApiApiSearchPlayersGet
     */
    readonly q: string
}

/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI {
    /**
     * Search for players, teams, competitions
     * @param {SearchApiApiSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public apiSearchGet(requestParameters: SearchApiApiSearchGetRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiSearchGet(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for leagues
     * @param {SearchApiApiSearchLeaguesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public apiSearchLeaguesGet(requestParameters: SearchApiApiSearchLeaguesGetRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiSearchLeaguesGet(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for players
     * @param {SearchApiApiSearchPlayersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public apiSearchPlayersGet(requestParameters: SearchApiApiSearchPlayersGetRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiSearchPlayersGet(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }
}

